﻿export interface IEmailEntityDeleteRequestContract {
    emailTemplateId: number;
    emailEntityId: number;
}
